export const TEAM = '3-5' as const;
